/**
 * @generated SignedSource<<ea0400c4387d6459c4e9e7dc2e97842b>>
 * @relayHash f504b87a4e0ed24c5467ba12a605952a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9123000e799c8af26e2146bcbeaf5a5445b2e622a89605e7d2dedac44d1c74aa

import type { ConcreteRequest } from 'relay-runtime';
export type useCustomUITunnelsListRelay_forge_ui_Query$variables = {
  appId: string;
  environmentId: string;
};
export type useCustomUITunnelsListRelay_forge_ui_Query$data = {
  readonly appActiveTunnels: {
    readonly customUI: ReadonlyArray<{
      readonly resourceKey: string | null | undefined;
      readonly tunnelUrl: AGG$URL | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useCustomUITunnelsListRelay_forge_ui_Query = {
  response: useCustomUITunnelsListRelay_forge_ui_Query$data;
  variables: useCustomUITunnelsListRelay_forge_ui_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "environmentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "appId",
        "variableName": "appId"
      },
      {
        "kind": "Variable",
        "name": "environmentId",
        "variableName": "environmentId"
      }
    ],
    "concreteType": "AppTunnelDefinitions",
    "kind": "LinkedField",
    "name": "appActiveTunnels",
    "plural": false,
    "selections": [
      {
        "concreteType": "CustomUITunnelDefinition",
        "kind": "LinkedField",
        "name": "customUI",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resourceKey"
          },
          {
            "kind": "ScalarField",
            "name": "tunnelUrl"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCustomUITunnelsListRelay_forge_ui_Query",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCustomUITunnelsListRelay_forge_ui_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "9123000e799c8af26e2146bcbeaf5a5445b2e622a89605e7d2dedac44d1c74aa",
    "metadata": {},
    "name": "useCustomUITunnelsListRelay_forge_ui_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f05d61452951b17f46031ee0cc173398";

export default node;
